import { render, staticRenderFns } from "./InsuranceTariffCard.vue?vue&type=template&id=92267110&scoped=true"
import script from "./InsuranceTariffCard.vue?vue&type=script&lang=js"
export * from "./InsuranceTariffCard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTariffCard.vue?vue&type=style&index=0&id=92267110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92267110",
  null
  
)

export default component.exports